import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LoadingDropdownSettings } from 'app/shared/dynamic-forms/form-models/event-emitter-entities/loading-more-settings';
import { LoadingDropdownControl } from 'app/shared/dynamic-forms/form-models/loading-dropdown-control';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'hb-df-loading-dropdown',
  templateUrl: './loading-dropdown.component.html',
  styleUrls: ['./dropdown-style.scss'],
})
export class LoadingDropdownComponent implements OnInit {
  @Input() control: LoadingDropdownControl;
  @Input() formGroup: FormGroup;

  @Output() onOverrideValue = new EventEmitter();

  readonly searchInputDebounceTime: number = 500;

  loading = false;
  input$ = new Subject<string>();
  settings = new LoadingDropdownSettings();

  constructor() { }
  ngOnInit() {
    this.onSearch();
  }

  onDropdownOpen() {

    if(this.settings.searchTerm){
      this.input$.next(this.settings.searchTerm);
    }else{
      this.requestLoadItems();

    }

  }
  public fetchMore() {
    this.settings.startItemNumber = this.control.options.length;
    this.initSelectedItem();
    this.requestLoadItems();
  }

  initSelectedItem() {
    this.settings.selectedItemId = this.control.selectedItemId;
  }

  public requestLoadItems() {
    this.control.requestLoadItems(this.settings);
  }

  public onSearch() {
    this.input$
      .pipe(
        debounceTime(this.searchInputDebounceTime),
        distinctUntilChanged(),
      )
      .subscribe(data => {
        this.settings.reset();
        this.settings.searchTerm = data;
        this.initSelectedItem();
        this.requestLoadItems();
      });
  }

  onClose() {
    if (this.settings.searchTerm) {
      this.input$.next(null);
    }
  }

  public overrideValue() {
    this.onOverrideValue.emit();
  }
}
